import {getEffortLevelFromGapCount, isRedeploymentPath} from './buildDepartmentHealthProfileDecisionGuideContext';
import {departmentHealthActionType, redeploymentChip} from '../../../../../layouts/theme/designSystem';
import type {DepartmentHealthEffortLevel, DepartmentHealthProfileSummary} from '../../types/DepartmentHealthTypes';

export type DepartmentHealthProfilePathChipStyles = {
  bgcolor: string;
  color: string;
};

const developPathStyles = departmentHealthActionType.developmentPlans;
const redeployPathStyles = redeploymentChip;

export const getDepartmentHealthProfilePathChipStyles = (
  profile: DepartmentHealthProfileSummary
): DepartmentHealthProfilePathChipStyles => {
  if (isRedeploymentPath(profile)) {
    return {
      bgcolor: redeployPathStyles.bgcolor,
      color: redeployPathStyles.color,
    };
  }

  return {
    bgcolor: developPathStyles.iconBg,
    color: developPathStyles.iconColor,
  };
};

export const getDepartmentHealthProfileEffortLevel = (
  profile: DepartmentHealthProfileSummary
): DepartmentHealthEffortLevel => profile.effortLevel ?? getEffortLevelFromGapCount(profile.gapCount);
